<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="服务网点" prop="nursinghomeId" required>
              <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width:100%"
                placeholder="请选择 服务网点"
              >
                <el-option
                  v-for="item in nursinghomeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="服务类型" prop="serviceType">
              <el-select v-model="form.serviceType" style="width:100%" placeholder="请选择 服务类型">
                <el-option
                  v-for="item in typeDice"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务名称" prop="name">
              <el-input v-model="form.name" maxlength="100" showWordLimit clearable  placeholder="请输入 服务名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input size="small" v-model="form.sort" maxlength="3" showWordLimit placeholder="请输入 排序"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input
                v-model="form.description"
                maxlength="200"
                showWordLimit
                type="textarea"
                clearable
                placeholder="请输入 备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { getNursinghomeList } from '../api/public.js';
import { getDictionary } from '@/api/common.js';
import { serviceItemSave,serviceItemDetail,serviceItemUpdate } from '../api/serveItemManage.js';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      nursinghomeList: [],
      typeDice: [],
      form: {
        nursinghomeId: '',
        serviceType: '',
        name: '',
        sort:'',
        description:"",
      },
      formRules: {
        name: [{ required: true, message: '服务名称不能为空', trigger: 'blur' }],
        nursinghomeId: [{ required: true, message: '服务网点不能为空', trigger: 'change' }],
        serviceType: [{ required: true, message: '服务类型不能为空', trigger: 'change' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'change' },
              { pattern: /^\+?[1-9][0-9]*$/, message: '只能输入正整数', trigger: 'change'}],
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
   
    async initData() {
      getDictionary('nursinghome_service_type').then((res) => {
        this.typeDice = res.data;
      });
      getNursinghomeList().then((res) => {
        this.nursinghomeList = res.data;
      });
      if (this.model == 'add') {
        this.form.nursinghomeId = this.nursinghomeId;
        
      } else {
        serviceItemDetail(this.row).then((res) => {
          this.form = res.data;
        })
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if ((this.model == 'add')) {
            serviceItemSave(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }else{
            serviceItemUpdate(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
